import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/app/(auth)/signup/page.tsx");
